import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Report } from "./report.model";
import { environment } from "src/environments/environment";
import { Subject } from "rxjs/internal/Subject";
import { Utils } from "src/app/_helpers/utils";
import { Subscription } from "rxjs";

const url = environment.api;

@Injectable({
  providedIn: "root",
})
export class ReportService {
  report: Report = new Report();
  reports: Report[];
  attachmentFile: File;
  attachmentFiles: File[] = [];
  attachmentRemove: boolean;

  filterDetailsSubject: Subject<any> = new Subject<any>();

  filterDetailsShowLoader: boolean;
  loading: boolean = false;

  reportFilter = {
    statusValue: "null",
    status: null,
    priorityValue: "null",
    priority: null,
  };

  public actualSubscription: Subscription = new Subscription();

  constructor(private http: HttpClient) {}

  reloadFilter() {
    this.filterDetailsSubject.next(null);
  }

  createReport(fileData: any) {
    return this.http.post(url + "report", fileData);
  }

  getReports(params: {
    idUserCreatedBy?: number;
    closed?: string;
    status?: string;
    priority?: string;
  }) {
    return this.http.get<Report[]>(url + "report", {
      params: Utils.httpParams(params),
    });
  }

  getReport(ReportId: string) {
    return this.http.get<Report>(url + "report/" + ReportId);
  }

  updateReport() {
    if (this.report.priority === undefined) {
      delete this.report.priority;
    }

    if (this.report.status === undefined) {
      delete this.report.status;
    }

    return this.http.put(url + "report/" + this.report.id, this.report);
  }

  deleteReport(ReportId: string) {
    return this.http.delete(url + "report/" + ReportId);
  }
}
